import { faPlus, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './index.css'

const Index = ({notes,setNotes,setPage}) => {
  return (
    <div className='labadmin_orders_new_lineitems_container'>
      <div className='labadmin_orders_new_lineitems_add'>
        <p>Notes</p>
        <button onClick={()=>{
          let note = prompt("Please enter a note", "");

          if (note !== null && note !== '') {
            const sendData = [];
            for (let index = 0; index < notes.length; index++) {
              const element = notes[index];
              sendData.push(element);
            }
            sendData.push(note);
            setNotes(sendData)
          }
        }}>
          <FontAwesomeIcon icon={faPlus}/>
        </button>
      </div>
      {notes.length > 0 &&
      <div className='labadmin_orders_new_lineitems_list'>
        <div className='_table'>
          <div className='_tbody'>
              {
                notes.map((item,index)=>{
                  return(
                    <div className='_tr' key={index}>
                      <div className='_td' style={{width:"90%"}}>{item}</div>
                      <div className='_td' style={{width:"10%"}}><FontAwesomeIcon icon={faTrashCan} onClick={()=>{
                        const sendData = [];
                        for (let index2 = 0; index2 < notes.length; index2++) {
                          const element = notes[index2];
                          if(index !== index2){
                            sendData.push(element);
                          }
                        }
                        setNotes(sendData)
                      }}/></div>
                    </div>
                  )
                })
              }
          </div>
        </div>
      </div>
      }
    </div>
  )
}

export default Index
